<template>
  <fn-form-field
    :id="id"
    v-model:value="model"
    :name="name"
    :float-label="false"
    :option="true"
    :rules="rules"
    vee-type="checkbox"
  >
    <template #default="slotProps">
      <fn-checkbox
        v-bind="bindings"
        :id="slotProps.field.name"
        v-model:value="slotProps.field.value"
        :label="label"
        :label-is-html="labelIsHtml"
        :name="slotProps.field.name"
        :required="required && showMandatory"
      >
        <template #afterLabel>
          <slot
            name="afterLabel"
            v-bind="slotProps.field"
          />
        </template>
      </fn-checkbox>
    </template>
  </fn-form-field>
</template>

<script setup lang="ts">
import { defineInputBindings } from '@/mixins/InputFieldAttributes';
import { defineFormFieldPropsDefaults, type FormFieldProps } from '@/mixins/FormField';

const props = withDefaults(
  defineProps<
    FormFieldProps & {
      labelIsHtml?: boolean;
      showMandatory?: boolean;
    }
  >(),
  {
    ...defineFormFieldPropsDefaults(),
    showMandatory: true,
  },
);
const model = defineModel<string | boolean>('value');
const bindings = defineInputBindings(props);
</script>
